import React from 'react';
import Hero from '../components/home/Hero';
import Stats from '../components/home/Stats';
import ServicesOverview from '../components/home/ServicesOverview';
import IndustriesOverview from '../components/home/IndustriesOverview';
import ClientSuccessPreview from '../components/home/ClientSuccessPreview';
import PartnerLogos from '../components/home/PartnerLogos';
import CTASection from '../components/home/CTASection';

const Home = () => {
  return (
    <div>
      <Hero />
      <Stats />
      <ServicesOverview />
      <IndustriesOverview />
      <ClientSuccessPreview />
      <PartnerLogos />
      <CTASection />
    </div>
  );
};

export default Home;